exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".group_body {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column; }\n  .group_body .dialogForm {\n    display: contents; }\n\n.field_flex {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  gap: 2rem; }\n  .field_flex .name_field {\n    -ms-flex-positive: 1;\n        flex-grow: 1;\n    cursor: not-allowed; }\n\nbutton {\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n  -ms-flex-item-align: end;\n      align-self: flex-end; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/dialog/edit-aspect-dialog/edit-aspect-dialog.component.scss
// module id = ../../../../../src/app/components/dialog/edit-aspect-dialog/edit-aspect-dialog.component.scss
// module chunks = main